import React, { useContext } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import PickUp from './pages/PickUp/index';
import Expose from './pages/Expose/index';
import { ICON_HTML } from './components/Icons';
import IFrame from './components/IFrame';
import { OverlayEnum } from './enums';
import Story from './pages/Story';
import SSPContentVO from 'sspcontentext/dist/model/SSPContentVO';
import SspProviderContext from './utils/SspProvider/context';
import InitLoading from './components/Loading/InitLoading/InitLoading';

function Main() {
    const store = useContext(SspProviderContext);
    const contentModel = store.state.content ? store.state.content.asModel : new SSPContentVO('').asModel;
    const editorialContent = contentModel.has('StoryItems');

    return (
        <div className='App'>
            {store.state.overlay?.enum === OverlayEnum.Loading && <InitLoading />}
            <div className='svgtemplates' dangerouslySetInnerHTML={{ __html: ICON_HTML }} />
            <HashRouter>
                <Routes>
                    <Route path='/pick-up' element={<PickUp editorialContent={editorialContent} />} />
                    <Route path='/story' element={<Story editorialContent={editorialContent} />} />
                    <Route path='/iframe/:url' element={<IFrame />} />
                    <Route path='/' element={<Expose editorialContent={editorialContent} />} />
                    <Route path='/error' element={<h1>Page not found</h1>} />
                </Routes>
            </HashRouter>
        </div>
    );
}

export default Main;
